<template>
  <div class="mt-3">
    <TopSection
      :title="$t('members')|capitalize"
      :count="count"
    >
      <template v-slot:status>
        <Status
          :count="states[statusTypes.ACTIVE] || 0"
          :text="$t('active') | capitalize"
          :icon="['fas', 'check-circle']"
          color="green"
        />
        <Status
          :count="states[statusTypes.PENDING] || 0"
          :text="$t('pending') | capitalize"
          :icon="['fas', 'question-circle']"
          color="orange"
        />
        <Status
          :count="states[statusTypes.BLOCKED] || 0"
          :text="$t('blocked') | capitalize"
          :icon="['fas', 'exclamation-circle']"
          color="red"
        />
      </template>
    </TopSection>

    <v-server-table
      v-if="dataReady"
      ref="members"
      :url="url"
      :columns="columns"
      :options="options"
      @loaded="loaded"
      @pagination="onPagination"
      @sorted="onSorted"
      @filter="onFilter"
    >
      <!-- USERNAME COLUMN-->
      <template v-slot:username="{ row }">
        <div class="flex">
          <span class="mr-2 ml-3">
            <span class="mr-2">
              <img
                width="20"
                src="@/assets/img/mlc.png"
              >
            </span>
          </span>
          <div>
            <div class="table-main-class">
              {{ row.username }}
            </div>
            <div class="table-sub-class text-sm">
              {{ row.org_type||'-' }}
            </div>
          </div>
        </div>
      </template>

      <!-- CREATED(DATE) COLUMN-->

      <template v-slot:created="{ row }">
        <div class="table-main-class">
          {{ row.created | transformDate("MMMM Do YYYY") }}
        </div>
        <div class="table-sub-class text-sm">
          {{ row.created | transformDate("h:mm a") }}
        </div>
      </template>

      <template v-slot:status="{ row }">
        <Status
          v-if="row.society_status == statusTypes.ACTIVE"
          :text="$t('active') | capitalize"
          :icon="['fas', 'check-circle']"
          color="green"
        />
        <Status
          v-if="row.society_status == statusTypes.PENDING"
          :text="$t('pending') | capitalize"
          :icon="['fas', 'question-circle']"
          color="orange"
        />
        <Status
          v-if="row.society_status == statusTypes.BLOCKED"
          :text="$t('blocked') | capitalize"
          :icon="['fas', 'exclamation-circle']"
          color="red"
        />
      </template>

      <template v-slot:num_users="{ row }">
        <span
          v-b-tooltip.hover
          class="link-class"
          :title="$t('go_to_users')"
          @click="goToUsers(row.id)"
        >
          {{ row.num_users }}
          <i class="far fa-users ml-2" />
        </span>
      </template>

      <!-- ACTIONS COLUMN-->
      <template v-slot:actions="{ row }">
        <i
          :id="row.id"
          v-b-tooltip.hover
          style="color:#6f6f6f; font-size:16px;"
          class="clickable float-right"
          :class="actionClass"
          :title="actionTooltip"
          @click="editMember(row.id)"
        />
      </template>
    </v-server-table>
  </div>
</template>

<script>
import { capitalize, get } from "lodash"
import {
  doRequest,
  responsePaginatedAdapter
} from "@/assets/libs/utils"
import { mapGetters, mapState } from "vuex"
import { ApiCalls } from "@/assets/libs/services"
import { listRouteMixin } from "@/utils/mixins"

export default {
  name: "MembersList",
  mixins: [listRouteMixin],

  data () {
    return {
      member_selected: [],
      active: "-",
      pending: "-",
      blocked: "-",
      url: "memberslist/",
      count: 0,
      show: true,
      columns: [
        "username",
        "created",
        "status",
        "num_users",
        "actions"
      ],
      options: {
        sortable: ["username", "created", "status", "org_type"],
        filterable: true,
        headings: {
          username: capitalize(this.$t("username")),
          created: capitalize(this.$t("created")),
          status: capitalize(this.$t("status")),
          num_users: capitalize(this.$t("num_users")),
          actions: ""
        },
        requestFunction (params) {
          this.$parent.$parent.updateStates(params)
          const queryParams = { ...params, ...this.$route.query }
          this.page = Number(get(queryParams, "page", 1))
          return doRequest(this.url, queryParams)
        },
        responseAdapter (resp) {
          return responsePaginatedAdapter(resp)
        }
      }
    }
  },
  computed: {
    ...mapGetters("soundsys", ["isBasic", "statusTypes"]),
    ...mapState("soundsys", ["dataReady"]),
    actionTooltip () {
      if (!this.isBasic) {
        return "edit"
      } else {
        return "details"
      }
    },
    actionClass () {
      if (!this.isBasic) {
        return "fa fa-pencil pr-4"
      } else {
        return "fa fa-eye"
      }
    },
    states () {
      const { active, pending, blocked } = this
      return { active, pending, blocked }
    }
  },
  methods: {
    getData () {
      this.$refs.members.getData()
    },
    goToUsers (member_id) {
      this.$router.push({
        name: "members-users-list",
        params: { member_id },
      })
    },
    loaded () {
      this.count = this.$refs.members.$refs.table.count || 0
    },
    editMember (id) {
      this.$router.push({
        name: "members-detail",
        params: { id }
      })
    },
    onFilter (search) {
      this.options.previousPage = null
      this.$router.replace({ query: { ...this.$route.query, fuzzy_search: search, page: 1 } })
    },
    updateStates () {
      ApiCalls.getMemberStates().then(x => {
        this.active = x.data.active || 0
        this.pending = x.data.pending || 0
        this.blocked = x.data.blocked || 0
      })
    },
    rerender () {
      this.show = false
      this.$nextTick(() => {
        this.show = true
        this.$nextTick(() => window.console.log("re-render members end"))
      })
    },
  },

  mounted () {
    this.updateStates()
  }
}
</script>
